import React, { useState, useMemo } from "react";
import { useIntl } from "react-intl";
import { Space } from "@masterteam/mt-design-react";

import ReportTypes from "./ReportTypes";
import StrategyReportFilters from "./Filters/strategyReport";
import CEOReportFilters from "./Filters/CEOReport";
import SectorReportFilters from "./Filters/SectorReport";

import "./style.scss";

const Reports = () => {
  const intl = useIntl();

  const items = useMemo(() => {
    return [
      {
        Name: intl.formatMessage({ id: "reports.ceo-report" }),
        Type: "CEOReport",
        Component: <CEOReportFilters />
      },
      {
        Name: intl.formatMessage({ id: "reports.sectors-report" }),
        Type: "SectorReport",
        Component: <SectorReportFilters />
      },
      {
        Name: intl.formatMessage({ id: "reports.strategic-strategy-report" }),
        Type: 1,
        Component: <StrategyReportFilters />
      }
    ];
  }, []);

  const [selectedReport, setSelectedReport] = useState(items[0]);

  return (
    <div className="reports-container">
      <Space size="medium">
        <div style={{ flex: 1 }}>
          <ReportTypes
            setSelectedReport={setSelectedReport}
            selectedReport={selectedReport}
            items={items}
          />
        </div>

        <div style={{ flex: 3 }}>{selectedReport?.Component}</div>
      </Space>
    </div>
  );
};

export default Reports;
